<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update PromoCode" @show="setUpdateData"  @hide="closeModal()">
    <div class="" v-if="show">
      <b-row>
        <b-col sm="8">
          <p-input v-model="form.promoCode" label="Promo Code" name="promoCode" :handler="$v" :formData="form" :disabled="!allowPromoCodeUpdate" type="text"/>
        </b-col>
        <b-col sm="4">
          <p-input v-model="form.quantity" label="Quantity" name="quantity" :handler="$v" :formData="form" type="number" helptext="Set 0 for unlimited redeem"/>
        </b-col>
        <b-col sm="6">
          <p-input v-model="form.expireOn" label="Expiry Date" name="expireOn" :handler="$v" :formData="form" type="date" helptext="Set empty for no expiry"/>
        </b-col>
        <b-col sm="6">
          <p-dropdown v-model="form.status" label="Status" name="status" :handler="$v" :formData="form" :options="statusOption" textKey="key" textValue="label"/>
        </b-col>
        <b-col sm="12">
          <p-input v-model="form.description" label="Description" name="description" :handler="$v" :formData="form" type="textarea"/>
        </b-col>
      </b-row>
    </div>
    <b-button variant="success" @click="update()" :disabled="requesting">Update</b-button>
    <b-button variant="outline-danger" @click="closeModal()">Cancel</b-button>
  </b-modal>
</template>

<script>

import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required, alphaNum, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import { PInput, PDropdown } from '../../../components'

export default {
  props: {
    showUpdateModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    },
    statusOption: {
      type: Array,
      default: []
    },
    operator: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      requesting: false,
      allowPromoCodeUpdate: false,
      form: {
        promoCode: '',
        quantity: 0,
        description: '',
        expireOn: '',
        status: null,
        errorMessages: {
          promoCode: {
            required: 'PromoCode is required',
            alphaNum: 'Should only contain number or alphabets',
            minLength: 'PromoCode should be between 5 to 20 characters',
            maxLength: 'PromoCode should be between 5 to 20 characters'
          },
          quantity: {
            required: 'Quantity is required',
            numeric: 'Should be number only'
          },
          description: {
            required: 'Description is required'
          },
          status: {
            required: 'Status is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      promoCode: { required, alphaNum, minLength: minLength(5), maxLength: maxLength(20) },
      quantity: { required, numeric },
      expireOn: {},
      description: { required },
      status: { required }
    }
  },
  components: {
    PInput,
    PDropdown
  },
  computed: {
    show: {
      get: function () {
        return this.showUpdateModal
      },
      set: function () {
        return this.showUpdateModal
      }
    }
  },
  methods: {
    async setUpdateData () {
      try {
        this.form.promoCode = this.updateData.PromoCode
        this.form.quantity = this.updateData.Quantity
        this.form.description = this.updateData.Description
        this.form.expireOn = this.updateData.ExpireOn
        this.form.status = this.updateData.Status
        this.allowPromoCodeUpdate = (this.updateData.TotalMember === 0)
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async update () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        this.requesting = true
        await this.$http.post(this.API_ENDPOINT + '/promotion/promoCode/update/' + this.updateData.Id, {
          promoCode: this.form.promoCode,
          quantity: this.form.quantity,
          description: this.form.description,
          expireOn: this.form.expireOn,
          status: this.form.status,
          operator: this.operator
        }, { headers: { 'Content-Type': 'application/json' } })

        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Poster Added Successfully')
        this.closeModal()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.requesting = false
      }
    },
    closeModal () {
      this.$emit('cancelUpdate')
      this.$v.form.$reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/promotion/promoCode/Update.vue